module.exports = __webpack_public_path__ + "static/img/bg-id.ae6da8a4.png";